import { render, staticRenderFns } from "./PatientBillBreakDown.vue?vue&type=template&id=35392d92&"
import script from "./PatientBillBreakDown.vue?vue&type=script&lang=js&"
export * from "./PatientBillBreakDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports